module.exports = __webpack_public_path__ + "static/media/tilda_1.f60acf8f.jpg";